// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.file.PersonDiagnosisImportResponse */
/* istanbul ignore next */
@GandalfModel
export class PersonDiagnosisImportResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	code!: string | null;

	@GandalfConstantDecorator(constants.CodeSet)
	@GandalfProperty({ designType: constants.CodeSet })
	codeSet!: constants.CodeSet | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	diagnosisDate!: Date;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	lastModificationDate!: Date | null;

	@GandalfProperty({ designType: String })
	longDescription!: string | null;

	@GandalfProperty({ designType: String })
	shortDescription!: string | null;

	@GandalfConstantDecorator(constants.PersonDiagnosisStatus)
	@GandalfProperty({ designType: constants.PersonDiagnosisStatus })
	status!: constants.PersonDiagnosisStatus;

}
